import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { AppContextService } from '../app-context.service';

@Injectable({
	providedIn: 'root',
})
export class SessionExpirationTimeoutService {
	private countTimeoutExpired = 0;
	private countTimeoutExpiredWarning = 0;
	private resetOnTrigger: Boolean = false;
	private timerSubscription: Subscription;
	private timer: Observable<number>;
	public timeoutExpired: Subject<number> = new Subject<number>();
	private timeoutMilliseconds = 20 * 60 * 1000; //default 20 min

	private timerWaringSubscription: Subscription;
	private timerWaring: Observable<number>;
	public timeoutExpiredWarning: Subject<number> = new Subject<number>();
	private timeoutWarningMilliseconds = this.timeoutMilliseconds - 60000; //default -1 minute than expiration time

	constructor(private appContext: AppContextService) {
		let tokenTimeToLive = this.appContext.getTokenTimeToLive();
		let tokenTimeToLiveValue = tokenTimeToLive != null ? tokenTimeToLive : 20;

		let tokenToBeExpiredWarningInMinutes = this.appContext.getTokenToBeExpiredWarningInMinutes();
		let tokenToBeExpiredWarningInMinutesValue = tokenToBeExpiredWarningInMinutes != null ? tokenToBeExpiredWarningInMinutes : 1;

		this.timeoutMilliseconds = tokenTimeToLiveValue * 60 * 1000;
		this.timeoutWarningMilliseconds = (tokenTimeToLiveValue - tokenToBeExpiredWarningInMinutesValue) * 60 * 1000;

		this.timeoutExpired.subscribe((n) => {
			console.log('timeoutExpired subject next.. ' + n.toString());
		});

		this.timeoutExpiredWarning.subscribe((n) => {
			console.log('timeoutExpiredWarning subject next.. ' + n.toString());
		});

		this.startTimer();
	}

	private setSubscription() {
		console.log('setSubscription()');

		if (this.timerSubscription) this.timerSubscription.unsubscribe();

		if (this.timerWaringSubscription) this.timerWaringSubscription.unsubscribe();

		this.timer = timer(this.timeoutMilliseconds);
		this.timerSubscription = this.timer.subscribe((n) => {
			this.timerComplete(n);
		});

		this.timerWaring = timer(this.timeoutWarningMilliseconds);
		this.timerWaringSubscription = this.timerWaring.subscribe((k) => {
			this.timerWarningComplete(k);
		});
	}

	public startTimer() {
		this.countTimeoutExpired = 0;
		this.countTimeoutExpiredWarning = 0;

		if (this.timerSubscription || this.timerWaringSubscription) {
			this.stopTimer();
		}
		this.setSubscription();
	}

	public stopTimer() {
		if (this.timerSubscription) this.timerSubscription.unsubscribe();

		if (this.timerWaringSubscription) this.timerWaringSubscription.unsubscribe();
	}

	public resetTimer() {
		this.startTimer();
	}

	private timerComplete(n: number) {
		console.log('timerComplete n:' + n.toString());

		this.timeoutExpired.next(++this.countTimeoutExpired);

		if (this.resetOnTrigger) {
			this.startTimer();
		}
	}

	private timerWarningComplete(n: number) {
		console.log('timerWarningComplete n:' + n.toString());

		this.timeoutExpiredWarning.next(++this.countTimeoutExpiredWarning);

		if (this.resetOnTrigger) {
			this.startTimer();
		}
	}
}
